import styled from 'styled-components';

const AuthOuterContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 20px;
`;

export default AuthOuterContainer;
